<template>
    <div class="px-4 pb-4 pt-2">
        <slot />
    </div>
</template>
